import React, { useEffect } from 'react';
import { Bell } from 'lucide-react';

const NotificationsInboxPage: React.FC = () => {
  useEffect(() => { document.title = 'Notificações'; }, []);

  return (
    <main className="px-4 py-6" id="main-content" role="main" aria-label="Notificações">
      <h1 className="mb-6 text-xl font-bold text-slate-900">Notificações</h1>
      <div className="flex flex-col items-center justify-center py-12 text-center">
        <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-slate-100">
          <Bell className="h-8 w-8 text-slate-300" aria-hidden="true" />
        </div>
        <h3 className="mb-1 text-sm font-semibold text-slate-900">Nenhuma notificação</h3>
        <p className="text-xs text-slate-500">Você está em dia.</p>
      </div>
    </main>
  );
};

export default NotificationsInboxPage;
